module.exports = __webpack_public_path__ + "static/img/fire.84e248c.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/news2/fire.png
// module id = cESD
// module chunks = 7